import { render, staticRenderFns } from "./table_config_column_edit.vue?vue&type=template&id=5f0cf403&scoped=true"
import script from "./table_config_column_edit.vue?vue&type=script&lang=js"
export * from "./table_config_column_edit.vue?vue&type=script&lang=js"
import style0 from "./table_config_column_edit.vue?vue&type=style&index=0&id=5f0cf403&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0cf403",
  null
  
)

export default component.exports